import { gql } from "@apollo/client";

export const GET_TICKETS = gql`
  query GetTickets($query: QueryInput, $ticket: TicketInput) {
    tickets(query: $query, ticket: $ticket) {
      tickets {
        _id
        id
        number
        subject
        customer_id
        contact {
          id
          name
          email
          address1
          address2
          city
          state
          zip
          phone
        }
        customer_business_then_name
        problem_type
        status
        created_at
        updated_at
        resolved_at
        received_at
        assets {
          id
          asset_serial
        }
        invoice_contacts {
          id
          name
          email
          address1
          address2
          city
          state
          zip
          phone
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;

export const GET_TICKETS_BY_CUSTOMER_ID = gql`
  query GetTicketsByCustomerId($customerId: ID!, $query: QueryInput) {
    tickets(query: $query, ticket: { customer_id: $customerId }) {
      tickets {
        _id
        id
        number
        subject
        customer_id
        customer_business_then_name
        problem_type
        status
        created_at
        updated_at
        resolved_at
        received_at
        assets {
          id
          asset_serial
        }
        invoice_contacts {
          id
          name
          email
          address1
          address2
          city
          state
          zip
          phone
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;

